import React from "react";
import classNames from "classnames";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { useIsDateLocked } from "@hooks/useIsDateLocked";
import { useIsGlFirst } from "@hooks/useIsGlFirst";
import { toDisplayDateOnly } from "@helpers/date";
import { TransactionDateColumnContent } from "@components/transactions/ListItem/TransactionDateColumnContent";
import { TransactionLockColumnContent } from "@components/transactions/ListItem/TransactionLockColumnContent";
import { TransactionDescriptionColumnContent } from "@components/transactions/ListItem/TransactionDescriptionColumnContent";
import { TransactionAmount } from "@components/transactions/TransactionAmount";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { TransactionCategoryColumnContent } from "@components/transactions/ListItem/TransactionCategoryColumnContent";
import { TransactionAccountColumnContent } from "@components/transactions/ListItem/TransactionAccountColumnContent";
import { TransactionCashLedgerColumnContent } from "@components/transactions/ListItem/TransactionCashLedgerColumnContent";
import styles from "./RuleTransactionsPreview.module.scss";

interface Props {
    transaction: TransactionListItem;
}

export const AppliedTransactionRow: React.FC<Props> = ({ transaction }) => {
    const { enabled: isGlFirst } = useIsGlFirst();
    const isLocked = useIsDateLocked(
        transaction.entity.id,
        toDisplayDateOnly(transaction.dateOnly ?? transaction.date),
    );

    return (
        <div className={classNames(styles.row, styles.bodyRow)}>
            <div className={styles.appliedSingleRow}>
                <div className={styles.transactionContent}>
                    <div className={styles.lockColumn}>
                        <TransactionLockColumnContent isLocked={isLocked} />
                    </div>
                    <div className={styles.dateColumn}>
                        <TransactionDateColumnContent
                            transaction={transaction}
                        />
                    </div>
                    <div className={styles.descriptionColumn}>
                        <TransactionDescriptionColumnContent
                            transaction={transaction}
                        />
                    </div>
                    <div className={styles.categoryColumn}>
                        {isGlFirst ? (
                            <TransactionCashLedgerColumnContent
                                transaction={transaction}
                            />
                        ) : (
                            <TransactionCategoryColumnContent
                                transaction={transaction}
                            />
                        )}
                    </div>
                    <TransactionAccountColumnContent
                        transaction={transaction}
                    />
                    <div
                        className={classNames(
                            styles.amountColumn,
                            styles.amountValue,
                        )}
                    >
                        <TransactionAmount
                            transaction={transaction}
                            addSign
                            color
                        />
                    </div>
                    <div className={styles.entityColumn}>
                        <EntityAvatar entity={transaction.entity} size="xs" />
                    </div>
                </div>
            </div>
        </div>
    );
};
